import React from 'react';
import PresetLibraryPage from './PresetLibraryPage';

// Keep existing /market links, while sharing discovery, cards and filters.
export default function MarketPage() {
  return <PresetLibraryPage market />;
}
